import React, { useEffect, useState, useRef } from "react";
import { Column } from '@ant-design/plots';
import AdminMainLayout from '../AdminMainLayout';
import { DatePicker, Row, Col, Dropdown, Button, Menu, Radio } from 'antd';
import DottedLoader from "../../DottedLoader";
import axios from "axios";
import ENVIRONMENT from '../../../../environments';
import { DownOutlined } from "@ant-design/icons";
import './index.scss';
const { RangePicker } = DatePicker;

function formatCurrency(amount, currency = 'USD', locale = 'en-US') {
    return amount.toLocaleString(locale, {
      style: 'currency',
      currency: currency,
    });
  }
  
  function transformDataCumulativeGrouped(data, graph_type = 'count') {
    const result = [];
    let cumulativeThreshold = 0;
    let cumulativeUsed = 0;
  
    for (const entry of data) {
      const { month } = entry;
  
      if (graph_type === 'count') {
        cumulativeThreshold += entry.threshold || 0;
        cumulativeUsed += entry.count || 0;
  
        result.push(
          { name: 'Target', month, value: Number(cumulativeThreshold.toFixed(2)) },
          { name: 'Delivered', month, value: Number(cumulativeUsed.toFixed(2)) }
        );
      } else {
        cumulativeThreshold += entry.threshold_amount || 0;
        cumulativeUsed += entry.total_amount || 0;
  
        result.push(
          { name: 'Target', month, value: Number(cumulativeThreshold.toFixed(2)) },
          { name: 'Delivered', month, value: Number(cumulativeUsed.toFixed(2)) }
        );
      }
    }
  
    return result;
  }
  
const GraphWithHeading = ({ title, data, company_id, graph_type = 'count' }) => {
    const yField = graph_type === 'dollar' ? 'total_amount' : 'count';
    const thresholdField = graph_type === 'dollar' ? 'threshold_amount' : 'threshold';
    const increaseMax = graph_type === 'dollar' ? 100 : 5;

    console.log(data)
    const getMonthDateRange = (interval) => {
        let start, end;
        if (interval.includes('Q')){
            let [quarter, year] = interval.split('/');  
            quarter = quarter.replace('Q', '');
            year = `20${year}`
            const quarterStartMonth = (parseInt(quarter) - 1) * 3; 
            start = new Date(year, quarterStartMonth, 1);
            end = new Date(year, quarterStartMonth + 3, 0);
        }
        else if (interval.includes('H')) {  
            // Semi-annual format: "2024-H1"
            const [year, half] = interval.split('-H');  
            const halfStartMonth = half === "H1" ? 0 : 6;  
            start = new Date(year, halfStartMonth, 1);
            end = new Date(year, halfStartMonth + 6, 0);
        }
        else if (interval.includes('/')) {  
            // Monthly format: "January/24"
            const [monthName, yearSuffix] = interval.split('/'); 
            const year = `20${yearSuffix}`; // Convert "24" to "2024"
            const monthIndex = new Date(Date.parse(monthName + " 1, 2024")).getMonth(); 
            start = new Date(year, monthIndex, 1);
            end = new Date(year, monthIndex + 1, 0);  // Last day of the month
        }  
        else {  
            // Annual format: "2024"
            start = new Date(interval, 0, 1);
            end = new Date(interval, 11, 31);
        }
    
        // Format dates as MM/DD/YYYY
        const formatDate = (date) => {
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const yyyy = date.getFullYear();
            return `${mm}/${dd}/${yyyy}`;
        };
    
        return {
            start: formatDate(start),
            end: formatDate(end),
        };
    };
    

    const maxCount = Math.max(...data.map((d) => d[yField]), ...data.map((d) => d[thresholdField])) + increaseMax;

    const groupedThresholds = [];
    let currentGroup = { 
    start: data[0].month, 
    threshold: data[0][thresholdField] 
    };

    for (let i = 1; i < data.length; i++) {
    if (data[i][thresholdField] !== currentGroup.threshold) {
        currentGroup.end = data[i - 1].month;

        // Add indices
        currentGroup.start_index = data.findIndex(d => d.month === currentGroup.start);
        currentGroup.end_index = i - 1;

        groupedThresholds.push({ ...currentGroup });

        currentGroup = { 
        start: data[i].month, 
        threshold: data[i][thresholdField] 
        };
    }
    }

    // Final group
    currentGroup.end = data[data.length - 1].month;
    currentGroup.start_index = data.findIndex(d => d.month === currentGroup.start);
    currentGroup.end_index = data.length - 1;
    groupedThresholds.push({ ...currentGroup });

    console.log(groupedThresholds)
    const config = {
        data,
        xField: 'month',
        yField: yField,
        color: (datum) => {
            let monthData = data.find(item => item.month === datum.month)
            return monthData[yField] > monthData[thresholdField] ? '#e6e600' : '#fa8c8d';
        },
        columnStyle: {
        radius: [4, 4, 0, 0],
        },
        annotations: groupedThresholds.map((group) => ({
            type: 'line',
            start: [group.start_index - 0.4, group.threshold],  // Start from the first month in range
            end: [group.end_index + 0.4 , group.threshold],  // End at the last month in range
            style: {
                stroke: '#ff4d4f',
                lineDash: [],
                lineWidth: 4,
            },
            text: {
                content: `Limit: ${(graph_type == "dollar" ? formatCurrency(group.threshold) : group.threshold.toFixed(2))}`,
                position: 'end',
                offsetX: -50,
                offsetY: -10,
                style: {
                    fontWeight: 'bold',
                },
            },
        })),
        tooltip: {
            formatter: (datum) => ({
                name: graph_type === 'dollar' ? 'Monthly Spend ($)' : 'Monthly Count',
                value: graph_type === 'dollar' ? formatCurrency(datum[yField]) : datum[yField],
            }),
        },
        xAxis: {
        title: { text: 'Month' },
        },
        yAxis: {
            title: { text: graph_type === 'dollar' ? 'Monthly Spend ($)' : 'Monthly Count' },
            max: maxCount,
        },
        legend: false, // No legend needed for a single dataset
        label: {
            position: 'top',
            content: (originData) => {
                return (graph_type == "dollar" ? formatCurrency(originData[yField]) : originData[yField])
            },
        },
        style: {
            fontSize: 16, 
            fontWeight: 'bold',
            textAlign: 'center', 
        },
        onReady: (plot) => {
            plot.on('element:click', (event) => {
                const { month } = event.data.data;
                let date_range = getMonthDateRange(month)
                window.open(`/admin-company-usage/${company_id}?startDate=${date_range.start}&endDate=${date_range.end}` , '_blank')
            });
        },
    };
    return (
        <div style={{ marginBottom: '40px' }}>
        <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>{title}</h4>
        <Column {...config} />
        </div>
    );
};

const GraphWithHeadingCumulative = ({ title, data, company_id, graph_type = 'count' }) => {
    const chartData = transformDataCumulativeGrouped(data, graph_type).sort((a, b) => {
        const order = { "Delivered": 0, "Target": 1 };
        return order[a.name] - order[b.name];
    });

    const config = {
        data: chartData,
        xField: 'month',
        yField: 'value',
        seriesField: 'name',
        isGroup: true,
    }

    return (
        <div style={{ marginBottom: '40px' }}>
        <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>{title}</h4>
        <Column {...config} />
        </div>
    );
};
const CustomerMonthlyUsageWithThreshold = () => {
    const [contractDateLoader, setContractDateLoader] = useState(true);
    const [usageLoader, setUsageLoader] = useState(true);
    const [contractData, setContractData] = useState({});
    const [usageData, setUsageData] = useState({});
    const [selectedContract, setSelectedContract] = useState(null);
    const [baseDataMap, setBaseDataMap] = useState({});
    const [contractCompanies, setContractCompanies] = useState([]);
    const [HaveCustomValues, setHaveCustomValues] = useState(false);
    const [graphType, setGraphType] = useState('count');
    const [usageFilter, setUsageFilter] = useState('billing_date');
    const [graphSetting, setGraphSetting] = useState('monthly');
    

    let company_id = new URLSearchParams(window.location.search).get("company_id")
    let company_name = new URLSearchParams(window.location.search).get("company_name")
    const [selectedCompany, setSelectedCompany] = useState(company_name);
    const [selectedCompanyId, setSelectedCompanyId] = useState(company_id);

    const fetchCompanies = () => {
        let payload = {'contract': true}
        axios.post(ENVIRONMENT.COMPANY_GET_BATCH, payload)
        .then(res => {
        console.log(res);
        console.log(res.data);
        var data = [];
        for (let i = 1; i <= (res.data).length; i++) {
         if (res.data[i - 1]['contracts_data'].length > 0){
            data.push({
                key: i,
                company_id: res.data[i - 1]['company_id'],
                company_domain: res.data[i - 1]['company_domain'],
                company_display_name: res.data[i - 1]['company_display_name'],
                shared_entities: res.data[i - 1]['shared_entities'],
                contracts: res.data[i - 1]['contracts_data']
              });
         } 
        }
        // sort alpahabatically
        data = data.sort(function (a, b) {
          return (a.company_display_name.toLowerCase() > b.company_display_name.toLowerCase() ? 1 : -1);
        });
        console.log(data);
        setContractCompanies(data);
      })
    }

    useEffect(() => {
        const url = new URL(window.location);
        url.searchParams.set("company_id", selectedCompanyId);
        url.searchParams.set("company_name", selectedCompany);        
        window.history.pushState({}, "", url);
        setContractDateLoader(true);
        
        setUsageLoader(true);
        fetchCompanies();
        let payload = {
            company_id: selectedCompanyId,
            action: 'get_company_contract_quota'
        }

        axios.post(ENVIRONMENT.CUSTOMER_CONTRACT_CONTROLLER, payload)
        .then(res => {
            setContractData(res.data);
            setContractDateLoader(false);

            Object.keys(res.data).forEach((key) => {
                res.data[key]['services_quota'].forEach((service) => {
                    if(service.custom_input){
                        setHaveCustomValues(true);
                    }
                })
            })

            const keys = Object.keys(res.data);
            if (keys.length === 2 && keys.includes("all")){
                const contractIdKey = keys.find(key => key !== "all");
                setSelectedContract(contractIdKey);
            }
            else{
                setSelectedContract('all');
            }
        })    
    }, [selectedCompanyId])


    useEffect(() => {
        if (Object.keys(usageData).length > 0) {
            let updatedDataMap = { ...baseDataMap };
    
            Object.keys(usageData).forEach((type) => {
                let serviceData = contractData[`${selectedContract}`].services_quota.find((service) => service.service_name === type);
                if (serviceData) {
                    let quota = serviceData.interval_quota;
                    let typeData = [];
    
                    for (let key in quota) {
                        let formattedDate = "";
                        let count = usageData[type][key] || 0;
    
                        if (key.includes('-Q')) {
                            // **Quarterly Handling (YYYY-QN)**
                            let [year, quarter] = key.split('-Q');
                            formattedDate = `Q${quarter}/${year.slice(-2)}`;
                        } 
                        else if (key.includes('-H')) {
                            // **Half-Yearly Handling (YYYY-HN)**
                            let [year, half] = key.split('-H');
                            formattedDate = `${half}/${year.slice(-2)}`;
                        } 
                        else if (/^\d{4}$/.test(key)) {
                            // **Annual Handling (YYYY)**
                            formattedDate = key;
                        } 
                        else {
                            // **Monthly Handling (YYYY-MM)**
                            // Parse date explicitly to avoid timezone issues
                            let [year, month] = key.split('-');
                            let date = new Date(parseInt(year), parseInt(month) - 1, 1); // month is 0-indexed
                            let monthName = date.toLocaleString('default', { month: 'long' });
                            let yearShort = date.getFullYear().toString().slice(-2);
                            formattedDate = `${monthName}/${yearShort}`;
                        }
    
                        typeData.push({
                            threshold: quota[key],
                            threshold_amount: quota[key] * serviceData['unit_price'],
                            total_amount: count * serviceData['unit_price'],
                            month: formattedDate,
                            count: count
                        });
                    }
    
                    updatedDataMap[type] = typeData;
                }
            });
            console.log(updatedDataMap)
            setBaseDataMap(updatedDataMap);
        }
    }, [usageData]);
    


    const handleMenuClick = ({ key }) => {
        setGraphSetting('monthly');
        setSelectedContract(key);
    }

    const handleCompanyChangeClick = ({ key }) => {
        setSelectedContract(null);
        const selectedCompanyObj = contractCompanies.find(company => company.company_id === key);
        setSelectedCompany(selectedCompanyObj.company_display_name);
        setSelectedCompanyId(key);
    }

    useEffect(() => {
        if(Object.keys(contractData).length === 0 || selectedContract == null) return
        setHaveCustomValues(false);
        setUsageLoader(true);
        console.log("selectedContract", selectedContract)
        let payload = {
            company_id: company_id,
            start_date: contractData[`${selectedContract}`].start_date,
            end_date: contractData[`${selectedContract}`].end_date,
            duration_type: selectedContract == 'all' ? 'monthly' : contractData[`${selectedContract}`].contract_type == 'project_based' ? 'annually' : contractData[`${selectedContract}`].usage_distribution,
            time_filter: usageFilter
        }

        contractData[selectedContract]['services_quota'].forEach((service) => {
            if(service.custom_input){
                setHaveCustomValues(true);
            }
        })
        setGraphType('count');
        axios.post(ENVIRONMENT.GET_CUSTOMER_USAGE, payload)
        .then(res => {
            setUsageData(res.data);
            setUsageLoader(false);
        })
    }, [selectedContract, usageFilter])

    // Headings and datasets for each graph
    const graphData = [
        { title: 'Product Models', data: baseDataMap['Product models']},
        { title: 'AR Models', data: baseDataMap['AR models']},
        { title: 'Variants', data: baseDataMap['Variants']},
        { title: 'Upload existing models', data: baseDataMap['Upload existing models']},
        { title: 'Bedding', data: baseDataMap['Bedding']},
        { title: 'Lifestyle images (4K)', data: baseDataMap['Lifestyle images (4K)']},
        { title: 'Lifestyle images (1K)', data: baseDataMap['Lifestyle images (1K)']},
        { title: 'Silo images (4K)', data: baseDataMap['Silo images (4K)']},
        { title: 'Silo Products', data: baseDataMap['Silo Products']},
        { title: 'Designed scenes', data: baseDataMap['Designed scenes']},
        { title: '360 spins', data: baseDataMap['360 spins']},
    ];
    const cellStyle = {
        border: "1px solid #ddd",
        padding: "8px 0px",
        textAlign: "center"
    };

    const contractsDropdown = (
        <Dropdown 
          overlay={
            <Menu onClick={handleMenuClick} selectedKeys={[selectedContract]}>
              {Object.keys(contractData).map((item) => {
                return (<Menu.Item key={item}>
                    {
                        item == 'all' ? 'All' : `${contractData[item].contract_type == "annual" ? "Annual" : 'Project'} contract starting ${contractData[item].start_date}`
                    }
                    </Menu.Item>)
              })}
            </Menu>
          }
          trigger={['click']}>
              <Button style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{overflow: 'hidden'}}>
                      {(selectedContract == null || selectedContract == 'all') ? 'All' : `${contractData[selectedContract].contract_type == "annual" ? "Annual" : 'Project'} contract starting ${contractData[selectedContract].start_date}`}
                  </div>
                  <DownOutlined style={{ marginLeft: 8 }} />
              </Button>
          </Dropdown>
        )
    
        const companiesDropdown = (
            <Dropdown 
              overlay={
                <Menu onClick={handleCompanyChangeClick} selectedKeys={[selectedCompanyId]}>
                  {contractCompanies.map((item) => {
                    return (<Menu.Item key={item.company_id}>
                        {
                            item.company_display_name
                        }
                        </Menu.Item>)
                  })}
                </Menu>
              }
              trigger={['click']}>
                  <Button style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{overflow: 'hidden'}}>
                          {selectedCompany}
                      </div>
                      <DownOutlined style={{ marginLeft: 8 }} />
                  </Button>
              </Dropdown>
            )

    return (
        <AdminMainLayout selected={"9"}>
        
        {usageLoader || contractDateLoader ? <DottedLoader /> :
        <>
            <Row className="mt-10 justify-in-start" gutter={12}>
                <Col span={15}>
                    <span className="sub-heading" style={{marginRight: 10}}>Customer Usage with Respect to Contract</span>
                    {companiesDropdown}
                </Col>
                <Col span={9} className="justify-in-end">
                    <Radio.Group onChange={(e) => setGraphSetting(e.target.value)} defaultValue={graphSetting} className="custom-radio-group" style={{marginRight: 10}}>
                        <Radio.Button value="monthly">Monthly</Radio.Button>
                        <Radio.Button value="cumulative">Cumulative</Radio.Button>
                    </Radio.Group>
                    {contractsDropdown}
                </Col>
            </Row>
            <Row className="mt-10 justify-in-between" gutter={12}>
                <Col span={17}>
                    {HaveCustomValues ? <span>* There are custom items in this contract which are not visible in the below data visualizations. </span> : ""}
                    {selectedContract != "all" ? <span>You can view contract details <a href={`/customer_contract_form?action=view&contract_id=${selectedContract}`} target="_blank">here</a>.</span> : ""}
                </Col>
                <Col span={4} className="justify-in-end mr-10">
                    <Radio.Group onChange={(e) => setGraphType(e.target.value)} defaultValue={graphType} className="custom-radio-group">
                        <Radio.Button value="count">Count</Radio.Button>
                        <Radio.Button value="dollar">Dollar Value</Radio.Button>
                    </Radio.Group>
                </Col>
                <Col span={2} className="justify-in-end">
                <Dropdown 
                    overlay={
                        <Menu onClick={(key) => setUsageFilter(key.key)} selectedKeys={[usageFilter]}>
                            <Menu.Item key="created_on">
                                Created On
                            </Menu.Item>
                            <Menu.Item key="billing_date">
                                Billed On
                            </Menu.Item>
                        </Menu>
                    }
                    trigger={['click']}>
                        <Button style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{overflow: 'hidden'}}>
                                {usageFilter == "created_on" ? "Created On" : "Billed On"}
                            </div>
                            <DownOutlined style={{ marginLeft: 8 }} />
                        </Button>
                    </Dropdown>
                </Col>
            </Row>
            <div style={{ padding: '40px' }}>
                {graphData.map((graph, index) => (
                graphSetting == 'cumulative' ? 
                <GraphWithHeadingCumulative
                    key={index}
                    title={graph.title}
                    data={graph.data}
                    company_id={company_id}
                    graph_type={graphType}
                />
                :
                <div>
                    <GraphWithHeading
                        key={index}
                        title={graph.title}
                        data={graph.data}
                        company_id={company_id}
                        graph_type={graphType}
                    />
                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px", marginBottom: "50px" }}>
                        <thead>
                            <tr>
                                <th style={cellStyle}>Contract Year</th>
                                {graph.data.map((item) => (
                                    <th key={item.month} style={cellStyle}>
                                        {item.month.includes("/") 
                                            ? `${item.month.split("/")[0].substring(0,3)}/${item.month.split("/")[1]}`
                                            : item.month}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={cellStyle}><strong>Used Monthly</strong></td>
                                {graph.data.map((item, index) => (
                                    <td key={index} style={{...cellStyle, background: `${item.count > item.threshold ? '#fa8c8d' : '#1890ff96'}`}}>{graphType == 'count' ? item.count : formatCurrency(item.total_amount)}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={cellStyle}><strong>Contract Value</strong></td>
                                {graph.data.map((item, index) => (
                                    <td key={index} style={{...cellStyle, background: '#1890ff96'}}>{graphType == 'count' ? item.threshold : formatCurrency(item.threshold_amount)}</td>
                                ))}
                            </tr>
                        </tbody>
                    </table>    
                </div>
                
                ))
            }
            </div>
        </>
        }
        </AdminMainLayout>
    );
};

export default CustomerMonthlyUsageWithThreshold;